import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";

import * as importData from "../../../../constants/importData";
import * as formatHelper from "../../../../helpers/formatHelper";
import * as modelHelper from "../../../../helpers/modelHelper";
import * as componentTypes from "../../../../constants/componentTypes";
import * as navigationActions from "../../../../actions/navigationActions";
import * as actions from "../../../../actions/importDataActions";

import imgConfirm from "../../../../resources/img/svgicons/confirm.svg";
import imgCancel from "../../../../resources/img/svgicons/cancel2.svg";
import Modal from "../../../global/generic/Modal";
import Button from "../../../global/generic/Button";

class ImportDataModal extends Component {
    handleCloseModalClick = () => {
        this.props.dispatchCloseModalAction();
    };

    handleAbortImportingDataClick = () => {
        this.props.dispatchAbortImportingDataAction();
    };

    getProgressDescription = () => {
        if (this.props.aborting) {
            return (
                <span>
                    <Translate value="importData.importAborting" />
                    ...
                </span>
            );
        }

        if (this.props.aborted) {
            return <Translate value="importData.importAborted" />;
        }

        if (this.props.importing) {
            switch (this.props.task) {
                case importData.PROCESSING_CUSTOM_FORMULAS:
                    return (
                        <span>
                            <Translate value="importData.processingCustomFormulas" />
                            ...
                        </span>
                    );
                case importData.PROCESSING_CUSTOMERS:
                    return (
                        <span>
                            <Translate value="importData.processingCustomers" />
                            ...
                        </span>
                    );
                default:
                    return (
                        <span>
                            <Translate value="importData.processing" />
                            ...
                        </span>
                    );
            }
        }

        if (this.props.imported) {
            return <Translate value="importData.imported" />;
        }

        return "";
    };

    getProgressBar = () => {
        if (this.props.importing || this.props.aborting) {
            return (
                <div className="progress progress-dark col-xs-12 no-padding">
                    <div
                        className="progress-bar"
                        style={{width: `${formatHelper.convertDecimalToPercent(this.props.progress)}%`}}
                        role="progressbar"
                        aria-valuenow="0"
                        aria-valuemin="0"
                        aria-valuemax="100"
                    />
                    <span>
                        {formatHelper.formatFixedDecimal(formatHelper.convertDecimalToPercent(this.props.progress), 0)}{" "}
                        %
                    </span>
                </div>
            );
        }

        return "";
    };

    getAbortImportButton = () => {
        if (this.props.importing) {
            return (
                <Button
                    label={<Translate value="helperDialog.btnAbort" />}
                    svgBefore={imgCancel}
                    onClick={this.handleAbortImportingDataClick}
                />
            );
        }

        return "";
    };

    getConfirmButton = () => {
        if (this.props.imported || this.props.aborted) {
            return (
                <Button
                    label={<Translate value="general.confirm" />}
                    svgBefore={imgConfirm}
                    onClick={this.handleCloseModalClick}
                />
            );
        }

        return "";
    };

    getContent = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <div className="col-12 text-align-center margin-bottom-10">{this.getProgressDescription()}</div>
                <div className="col-12">{this.getProgressBar()}</div>
            </React.Fragment>,
            "col-12 flex-wrap"
        );
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                {this.getAbortImportButton()}
                {this.getConfirmButton()}
            </React.Fragment>
        );
    };

    render() {
        return (
            <Modal
                onClose={this.props.handleCloseModalClick}
                className="superior-modal"
                header={modelHelper.buildModalSection(<Translate value="importData.importing" />)}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={{minWidth: "50%"}}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        importing: store.importData.importing,
        imported: store.importData.imported,
        aborting: store.importData.aborting,
        aborted: store.importData.aborted,
        progress: store.importData.progress,
        task: store.importData.task
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.IMPORT_DATA_MODAL));
        },
        dispatchAbortImportingDataAction: () => {
            dispatch(actions.abortImportingData());
        }
    };
};

export default ImportDataModal = connect(mapStoreToProps, mapDispatchToProps)(ImportDataModal);
